import CommonMiddleware from 'yoda-site-components/lib/middlewares/CommonMiddleware';
import MiniPDPAnalyticsMiddleware from 'yoda-mini-pdp/lib/middlewares/MiniPDPAnalyticsMiddleware';
import MarketingMiddleware from './MarketingMiddleware';

const rootMiddleware = [CommonMiddleware, MarketingMiddleware, MiniPDPAnalyticsMiddleware];

export default rootMiddleware;
